import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Data, User } from '~/utils';
import LivePmlTable from './live-pml-table/live-pml-table.vue';

@Component({
    components: {
        LivePmlTable,
    }
})
export default class LivePmlComponent extends Vue {
    private userPermissions = <any>[];
    private isAccessDeniedModalActive: boolean = false;
    private data: Data = Data.Instance;

    async created() {
        this.userPermissions = await User.getPerm();
        if (!this.userPermissions.includes('SingleSitePageView')) {
            $('#accessDeniedModal').modal('show');
            this.isAccessDeniedModalActive = true;
        }
    }

    private onClickCancel(value) {
        this.isAccessDeniedModalActive = value;
    }
}
